import { NavLink } from "react-router-dom";
import type { ProjectPermission } from "../types";

interface Props {
  projectId: string;
  permission: ProjectPermission;
}

const ITEMS: { to: string; label: string; admin?: boolean }[] = [
  { to: "tasks", label: "Tasks" },
  { to: "tokens", label: "Access Tokens" },
  { to: "setup", label: "Project Setup" },
  { to: "agents", label: "Agents" },
  { to: "cost", label: "Cost Dashboard" },
  { to: "sharing", label: "Sharing", admin: true },
];

export default function Sidebar({ projectId, permission }: Props) {
  return (
    <aside className="sidebar">
      <nav>
        {ITEMS.filter((i) => !i.admin || permission === "administrator").map((i) => (
          <NavLink
            key={i.to}
            to={`/projects/${projectId}/${i.to}`}
            className={({ isActive }) => (isActive ? "active" : undefined)}
          >
            {i.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
